<template>
  <div>
    <vue-file-toolbar-menu :content="menu" class="custom-toolbar" />
    <div class="scrollable">
      <div class ref="editor"></div>
    </div>
  </div>
</template>

<script>
import { Alignment } from "@ckeditor/ckeditor5-alignment";
import { Bold, Code, Italic, Strikethrough, Underline } from "@ckeditor/ckeditor5-basic-styles";
import { BlockQuote } from "@ckeditor/ckeditor5-block-quote";
import { ClassicEditor } from "@ckeditor/ckeditor5-editor-classic";
import { Essentials } from "@ckeditor/ckeditor5-essentials";
import { Font, FontFamily } from "@ckeditor/ckeditor5-font";
import { Heading } from "@ckeditor/ckeditor5-heading";
import { Indent } from "@ckeditor/ckeditor5-indent";
import { Link } from "@ckeditor/ckeditor5-link";
import { List } from "@ckeditor/ckeditor5-list";
import { PageBreak } from "@ckeditor/ckeditor5-page-break";
import { Paragraph } from "@ckeditor/ckeditor5-paragraph";
import { PasteFromOffice } from "@ckeditor/ckeditor5-paste-from-office";
import { Table, TableCellProperties, TableProperties, TableToolbar } from "@ckeditor/ckeditor5-table";
import VueFileToolbarMenu from "vue-file-toolbar-menu";
export default {
  props: ["hideMagic", "magicMenuType"],
  components: { VueFileToolbarMenu },

  data() {
    return {
      editorInstance: undefined,
      editorConfig: {
        plugins: [
          PageBreak,
          Alignment,
          BlockQuote,
          Bold,
          Underline,
          Strikethrough,
          Code,
          Essentials,
          Heading,
          Indent,
          Italic,
          Link,
          List,
          PasteFromOffice,
          Paragraph,
          Table,
          TableToolbar,
          TableCellProperties,
          TableProperties,
          Font,
          FontFamily,
        ],
        toolbar: [
          "Undo",
          "Redo",
          "Heading",
          "FontFamily",
          "FontSize",
          "FontColor",
          "FontBackgroundColor",
          "Bold",
          "Code",
          "Italic",
          "Underline",
          "StrikeThrough",
          "Link",
          "insertTable",
          "Blockquote",
          "Alignment",
          "BulletedList",
          "NumberedList",
          "Outdent",
          "Indent",
          "PageBreak",
        ],
        table: {
          contentToolbar: ["tableColumn", "tableRow", "mergeTableCells", "tableProperties", "tableCellProperties"],
        },
      },
      content: "<h1>&nbsp;</h1>",
    };
  },

  mounted() {
    ClassicEditor.create(this.$refs.editor, this.editorConfig)
      .then((editor) => {
        this.editorInstance = editor;
        this.editorInstance.setData(this.content);

        const tryRemovePoweredBy = () => {
          setTimeout(() => {
            const a = document.getElementsByClassName("ck-powered-by-balloon");
            if (a.length > 0) {
              a.forEach((i) => {
                i.remove();
                this.removed = true;
              });
            }
            if (!this.removed) {
              tryRemovePoweredBy();
            }
          }, 2000);
        };
        tryRemovePoweredBy();
      })
      .catch((error) => {
        console.error(error);
      });
  },
  computed: {
    menu() {
      let menu = [];

      if (!this.hideMagic) {
        if (this.magicMenuType == "report") {
          menu = [
            {
              // Magic menu
              text: this.$t("magic.title"),
              title: this.$t("magic.title"),
              icon: "auto_awesome",
              chevron: true,
              menu_width: 300,
              menu_class: "align-center",
              menu: [
                {
                  menu_width: 400,
                  text: this.$t("organization.text"),
                  icon: "auto_awesome",
                  menu: [
                    {
                      text: this.$t("magic.organization"),
                      icon: "tag",
                      click: () => {
                        this.insertText("#Organization#");
                      },
                    },
                    {
                      text: this.$t("magic.organization-title"),
                      icon: "tag",
                      click: () => {
                        this.insertText(`#Organization Title#`);
                      },
                    },
                  ],
                },
              ],
            },
          ];
        }
      }

      return menu;
    },
  },

  watch: {
    content: {
      handler(new_content) {
        if (this.editorInstance) {
          this.editorInstance.setData(new_content[0]);
        }
      },
    },
  },

  methods: {
    rePositionStickyElement() {
      const topBar = document.getElementById("page-topbar");
      const stickyElement = document.querySelector(".sticky");
      if (topBar) {
        stickyElement.style.top = topBar.clientHeight + "px";
      }
    },
    getEditorContent() {
      return this.editorInstance.getData();
    },

    insertText(text) {
      const selection = this.editorInstance.model.document.selection;
      const range = selection.getFirstRange();
      this.editorInstance.model.change((writer) => {
        writer.insert(text, range.start);
      });
    },
  },
};
</script>

<style lang="css">
.scrollable {
  position: relative;
  height: 1200px;
  overflow: auto;
}
.bar-button.open:hover {
  z-index: 99999999 !important;
}
.bar-button > .menu.align-center {
  left: 0 !important;
}
.custom-toolbar .bar-menu-item {
  font-size: 16px;
  padding: 4, 4, 4;
}
</style>
